import { DialogProps } from "@mui/material";
import { createContext, ReactNode, useContext } from "react";

export interface BaseDialogProps extends DialogProps {
  open: boolean;
  onClose: () => void;
}

export type DialogFactory = (props: BaseDialogProps) => ReactNode;

export interface DialogManager {
  openDialog: (factory: DialogFactory) => void;
}

export const DialogManagerContext = createContext<DialogManager | null>(null);

export function useDialogManager() {
  const context = useContext(DialogManagerContext);

  if (!context) {
    throw new Error("useDialogManager must be used within DialogManager");
  }

  return context;
}
